export default "__VITE_ASSET__2e1c7484__"